define('apps/admin/views/components/admin-toast-message',[
        'app',
        '@discoveryedu/nebula-components',
        'vue',
        'common/components/vue-wrapper/helpers/mount-vue-component'
    ], function(app, NebulaComponents, Vue, mountVueComponent) {
        'use strict';

        var vueElProps = Vue.reactive({
            'toastMessages': [],
        });

        return {
            'vueEl': {},

            'appendNewToastMessage': function(messageObject) {
                vueElProps.toastMessages.push(messageObject);
            },

            'renderToastMessage': function() {
                vueElProps.onRemoveToastMessage = _.bind(this.removeToastMessage, this);

                this.vueEl = mountVueComponent(
                    NebulaComponents.NebulaToastMessages,
                    '.nebula-toast-message-queue',
                    vueElProps
                );
            },

            'removeToastMessage': function(id) {
                vueElProps.toastMessages = vueElProps.toastMessages.filter(function(msg) {
                    return msg.id !== id;
                });
            },

        };
});

